import { render, staticRenderFns } from "./waves.vue?vue&type=template&id=4eb38ec9&scoped=true&"
import script from "./waves.vue?vue&type=script&lang=js&"
export * from "./waves.vue?vue&type=script&lang=js&"
import style0 from "./waves.vue?vue&type=style&index=0&id=4eb38ec9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb38ec9",
  null
  
)

export default component.exports